import React from 'react';
import { connect } from 'react-redux';

import { changeFormField, setFieldError, setNewForm, updateFormProperties } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';
import InputSMS from 'apps/auth/components/form/InputSMS';
import Form from 'apps/auth/components/form-multi/Form';
import { getField } from 'apps/auth/components/form-multi/utils';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import update from 'immutability-helper';

import Loading from '../sms/Loading';

const RESEND_ACTION = '/auth/dual/factor/resend.action';
const CONFIRM_URL = '/auth/dual/factor/confirm.action';

const RESET_INTERVAL = 59;
const FORM_NAME = 'emailAuthentication';

class EmailAuthentication extends React.Component {
    constructor(props) {
        super(props);

        this.timerID = null;
        this.submitRef = React.createRef();

        this.state = {
            resetInterval: RESET_INTERVAL,
            showResend: false,
        };

        this.submitHandler = this.submitHandler.bind(this);
        this.resendClick = this.resendClick.bind(this);
    }

    componentDidMount() {
        this.props.setNewForm(FORM_NAME, { code: getField('code', '') });
        this.tick();
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    componentDidUpdate(props) {
        if (props.forms[FORM_NAME] && this.props.forms[FORM_NAME]) {
            let currentCode = this.props.forms[FORM_NAME].fields.code.value;
            let previousCode = props.forms[FORM_NAME].fields.code.value;
            if (currentCode && currentCode.length === 5 && currentCode !== previousCode) {
                this.submitRef.current.click();
            }
        }
    }

    submitHandler(fields, json) {
        if (json && json.errors) {
            Object.keys(json.errors).forEach((name) => {
                this.props.setFieldError(FORM_NAME, name, json.errors[name]);
            });
        }

        this.props.updateFormProperties(FORM_NAME, CONFIRM_URL);
    }

    tick() {
        if (this.timerID) {
            clearInterval(this.timerID);
        }
        this.timerID = setInterval(() => {
            const distance = this.state.resetInterval - 1;
            const seconds = distance >= 10 ? distance : '0' + distance;
            this.setState(
                update(this.state, {
                    resetInterval: { $set: seconds },
                }),
            );
            if (distance < 0) {
                clearInterval(this.timerID);
                //show resend
                this.setState(
                    update(this.state, {
                        showResend: { $set: true },
                    }),
                );
            }
        }, 1000);
    }

    clearErrorAndValue(oldField) {
        const newFieldCode = update(oldField, {
            value: { $set: null },
            isError: { $set: false },
            errorMessage: { $set: null },
        });
        this.props.changeFormField(FORM_NAME, newFieldCode);
    }

    resendClick(e) {
        e.preventDefault();
        new Promise((resolve) => {
            this.setState(
                update(this.state, {
                    resetInterval: { $set: RESET_INTERVAL },
                    showResend: { $set: false },
                }),
            );
            const { value, isError } = this.props.forms[FORM_NAME].fields.code;
            if (value || isError) {
                const fieldCode = this.props.forms[FORM_NAME].fields.code;
                this.clearErrorAndValue(fieldCode);
            }

            this.props.updateFormProperties(FORM_NAME, RESEND_ACTION).then(() => {
                this.submitRef.current.click();
                resolve(true);
            });
        }).then((resolve) => {
            if (resolve) {
                this.setState(
                    update(this.state, {
                        action: { $set: CONFIRM_URL },
                    }),
                );
                this.tick();
            }
        });
    }

    render() {
        if (!this.props.forms[FORM_NAME]) {
            return <Loading />;
        }
        const fields = this.props.forms[FORM_NAME].fields;
        return (
            <CommonPage backUrl={AUTH_SEND_MAIN_LINK} leftCloseIcon>
                <HeaderPanel title={this.props.enterAuthTitle} subtitle={this.props.authTitle} />
                <Form formName={FORM_NAME} field={fields} onSubmitHandler={this.submitHandler} action={CONFIRM_URL}>
                    <Row indent="24px">
                        <InputSMS field={fields.code} formName={FORM_NAME} focus={true} isNewInput isSmsInput />
                    </Row>
                    {this.state.showResend && (
                        <Row flex justify="center">
                            <Button variant="secondary" onClick={(e) => this.resendClick(e)} caption={this.props.authResendBtn} id="resend_sms_link" />
                        </Row>
                    )}
                    {!this.state.showResend && (
                        <Text size="secondary" color="lightGray">
                            {this.props.authResendTitle} 00:{this.state.resetInterval}
                        </Text>
                    )}
                    <Button type="submit" variant={'hidden'} ref={this.submitRef} />
                </Form>
            </CommonPage>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        forms: state.form,
        enterAuthTitle: state.messages.pageMessages.enterAuthTitle,
        authResendBtn: state.messages.pageMessages.authResendBtn,
        authResendTitle: state.messages.pageMessages.authResendTitle,
        authTitle: state.messages.pageMessages.authTitle,
    };
};
export default connect(mapStateToProps, {
    setNewForm,
    setFieldError,
    updateFormProperties,
    changeFormField,
})(BasePage(EmailAuthentication));
